// Kurzbeschreibung einer Automation-Regel (Auslöser + Zeitpunkt) für die UI.

const TRIGGERS = {
  appointment_created: 'Termin gebucht',
  appointment_confirmed: 'Termin bestätigt',
  appointment_confirmation: 'Termin bestätigt',
  appointment_upcoming: 'Termin steht an',
  appointment_reminder: 'Termin steht an',
  appointment_cancelled: 'Termin abgesagt',
  appointment_cancellation: 'Termin abgesagt',
  reschedule_day: 'Termin verschoben',
  invoice_created: 'Rechnung erstellt',
  invoice_reminder: 'Rechnung offen',
  rent_invoice_created: 'Mietrechnung erstellt',
  payment_reminder: 'Zahlung offen',
  reengagement_30d: 'Inaktiv seit 30 Tagen',
  reengagement_60d: 'Inaktiv seit 60 Tagen',
  reactivation: 'Reaktivierung',
  waitlist_joined: 'Auf Warteliste eingetragen',
  waitlist_slot_available: 'Platz auf Warteliste frei',
  trial_followup: 'Nach Probetraining',
  birthday: 'Geburtstag',
  birthday_gift: 'Geburtstag',
  review_request: 'Nach Besuch (Bewertung)',
  login_code: 'Login-Code (OTP)',
  manual_invoice_reminder: 'Rechnung offen (manuell)',
  event_announcement: 'Event-Ankündigung',
  event_reminder: 'Event-Erinnerung',
  class_reminder: 'Kurs-Erinnerung',
  class_cancelled: 'Kurs abgesagt',
  membership_expiring: 'Mitgliedschaft läuft ab',
  membership_expired: 'Mitgliedschaft abgelaufen',
  welcome: 'Willkommen',
  onboarding: 'Onboarding',
};

export function triggerLabel(rule) {
  const t = rule?.trigger;
  if (!t) return rule?.name || 'Auslöser';
  return TRIGGERS[t] || rule?.name || t;
}

export function timingText(rule) {
  const h = rule?.timing_hours;
  const type = rule?.timing_type;
  if (!type || type === 'immediate' || !h) return 'sofort';
  const abs = Math.abs(h);
  let unit;
  if (abs % 24 === 0) {
    const d = abs / 24;
    unit = d === 1 ? '1 Tag' : `${d} Tage`;
  } else {
    unit = abs === 1 ? '1 Stunde' : `${abs} Stunden`;
  }
  if (type === 'before') return `${unit} vorher`;
  if (type === 'after') return `${unit} danach`;
  return unit;
}

export function ruleSummary(rule) {
  if (!rule) return '';
  return `${triggerLabel(rule)} · ${timingText(rule)}`;
}
